<template lang="pug">
.checkbox-container(@click.stop="toggle")
  span.material-symbols-outlined(:style="iconStyle") {{ value ? 'check_box' : 'check_box_outline_blank' }}
  span.checkbox-label(v-if="label") {{ label }}
</template>

<script>
export default {
  name: 'Checkbox',

  props: {
    value: Boolean,
    label: String,
    iconColor: String,
    iconSize: String
  },

  computed: {
    iconStyle () {
      const style = {}

      if (this.iconColor) style.color = this.iconColor
      if (this.iconSize) style.fontSize = this.iconSize

      return style
    }
  },

  methods: {
    toggle () {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style lang="stylus" scoped>
.checkbox-container
  display inline-flex
  align-items center
  gap .5em
  cursor pointer
  user-select none

.material-symbols-outlined
  font-size 2rem

.checkbox-label
  font-size 1em
</style>



// WEBPACK FOOTER //
// src/components/elements/Checkbox.vue